// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"593":"ae7ab2d3","644":"cb677bde","655":"a806a9df","825":"2af18b70"}[chunkId] + ".chunk.css";
};